import { render, staticRenderFns } from "./PendingReceipts.vue?vue&type=template&id=7c783744&scoped=true"
import script from "./PendingReceipts.vue?vue&type=script&lang=js"
export * from "./PendingReceipts.vue?vue&type=script&lang=js"
import style0 from "./PendingReceipts.vue?vue&type=style&index=0&id=7c783744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c783744",
  null
  
)

export default component.exports